<template>
	<section
		class="testimonial section mb-24 pb-24"
		:class="[
			topOuterDivider && 'has-top-divider',
			bottomOuterDivider && 'has-bottom-divider',
			hasBgColor && 'has-bg-color',
			invertColor && 'invert-color',
		]"
	>
		<div class="container" style="transform: scale(1.015); transform-origin: top;">
			<div
				class="testimonial-inner section-inner pt-0"
				:class="[
					topDivider && 'has-top-divider',
					bottomDivider && 'has-bottom-divider',
				]"
			>
				<div
					class="tiles-wrap"
					:class="[pushLeft && 'push-left']"
				>
					<div
						v-for="repo in repos"
						v-bind:key="repo.name"
						class="tiles-item-spc"
                        :style="'max-height: 260;transition: max-height 0.15s ease-in-out; ' + (repo.hover ? '' : 'height: 260px')"
						@mouseover="repo.hover = true"
						@mouseleave="repo.hover = false"
					>
						<div
							class="tiles-item-inner has-shadow"
							:style="
								'border-radius: 28px; padding-top: 24px; transition: 0.5s ease-in-out; ' +
								(repo.hover ? 'opacity: 1 !important;' : '')
							"
						>
							<div
								class="testimonial-item-content reveal-scale-up"
								style="font-family: monospace"
								:data-reveal-delay="repo.delay"
							>
								<c-image
									:src="require('@/assets/images/github.png')"
									alt="Testimonial image 01"
									:width="36"
									:height="36"
								/>
								<p class="text-sm mb-8 mt-12">
									<b>{{ repo.name }}</b>
								</p>
								<div v-if="repo.hover == false">
									<p class="mb-0">
										<small id="forks">
											{{ repo.forks }}
										</small>
										<small> Forks</small>
									</p>
									<p class="mb-0">
										<small id="contributors">
											{{ repo.contributors }}
										</small>
										<small> Contributors</small>
									</p>
									<p class="mb-0">
										<small id="watchers">
											{{ repo.watchers }}
										</small>
										<small> Watchers</small>
									</p>
								</div>
								<div v-else>
									<p
										class="mt-24 pb-0"
										style="
											border-radius: 12px;
											border: 1px solid white;
											padding: 14px;
										"
									>
										<span class="text-xs text-color-low" style="display: block">
											Email Addresses
										</span>
										<span
											><small>
												~<ICountUp
													:delay="0"
													:endVal="repo.leads"
													:options="{ useEasing: true }"
												/> </small
										></span>
									</p>
									<p
										class="pb-0"
										style="
											border-radius: 12px;
											border: 1px solid white;
											padding: 14px;
										"
									>
										<span class="text-xs text-color-low" style="display: block">
											Popular Languages
										</span>
										<span
											><small>{{ repo.languages }}</small></span
										>
									</p>
									<p
										class="mb-0"
										style="
											border-radius: 12px;
											border: 1px solid white;
											padding: 14px;
										"
									>
										<span class="text-xs text-color-low" style="display: block">
											Interests
										</span>
										<span
											><small>{{ repo.interests }}</small></span
										>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
//import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

import ICountUp from "vue-countup-v2";

export default {
	name: "CTestimonial",
	components: {
		//CSectionHeader,
		CImage,
		ICountUp,
	},
	mixins: [SectionTilesProps],
	data() {
		return {
			repos: [
                {
					delay: 300,
					hover: false,
					name: "firebase/firebase-ios-sdk",
					contributors: 150,
					forks: 835,
					watchers: 213,
					leads: 0.85 * 1198,
					languages: "Objective-C, C++",
					interests: "Mobile Development, Swift",
				},
                {
					delay: 600,
					hover: false,
					name: "facebookresearch/ParlAI",
					contributors: 147,
					forks: 1600,
					watchers: 288,
					leads: 0.85 * 2035,
					languages: "Python, Javascript",
					interests: "Question Answering, ML",
				},
				{
					delay: 900,
					hover: false,
					name: "segmentio/nightmare",
					contributors: 114,
					forks: 1100,
					watchers: 371,
					leads: 0.85 * 1585,
					languages: "Javascript",
					interests: "Automation, UI Testing",
				}
			],
		};
	},
};
</script>